import { MAX_QUANTITY_NUMBER } from "@coworker/app/src/components/InputPopup/AddMultipleArticles.helper";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaQuantityStepper } from "@coworker/apprestructured/src/shared/wrappers/FixaQuantityStepper/FixaQuantityStepper";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import { SelectedItemCard } from "@coworker/apprestructured/src/task-management/components/AttachArticles/SelectedItemCard/SelectedItemCard";
import profilePreferences from "@coworker/enums/profilePreferences";
import { useTranslation } from "@coworker/locales";
import { ItemWithQuantity } from "../AttachArticles";
import styles from "./SelectedArticles.module.css";

interface SelectedArticlesProps {
  items: ItemWithQuantity[];
  onDeleteArticle: (no: string) => void;
  onQuantityChange: (no: string, quantity: number) => void;
  showQuantity?: boolean;
}

export const SelectedArticles = ({
  items,
  onDeleteArticle,
  onQuantityChange,
  showQuantity,
}: SelectedArticlesProps) => {
  const { t } = useTranslation();
  const [searchHistory, setSearchHistory] = useUserPreference<string[]>(
    profilePreferences.SEARCH_HISTORY,
    []
  );
  return (
    <ul className={styles["ul"]}>
      {items.map((article) => (
        <li
          key={article.no}
          className={
            showQuantity ? `${styles["li"]} ${styles["wrap"]}` : styles["li"]
          }
        >
          <SelectedItemCard
            item={article}
            setSearchHistory={setSearchHistory}
            searchHistory={searchHistory}
            handleProductClick={() => {}}
          />
          <div
            className={
              showQuantity
                ? `${styles["controls"]} ${styles["full-width"]}`
                : styles["controls"]
            }
          >
            {showQuantity && (
              <FixaQuantityStepper
                small
                minVal={1}
                maxVal={MAX_QUANTITY_NUMBER}
                className={styles["stepper"]}
                value={article.quantity}
                ariaDescribedBy={`Quantity for ${article.name}`}
                ariaDescribedById={`qty-${article.no}`}
                ariaLabelInput={t("quantityString", {
                  defaultValue: "Quantity",
                })}
                ariaLabelIncrease={t("increaseQuantityString", {
                  defaultValue: "Increase",
                })}
                ariaLabelDecrease={t("decreaseQuantityString", {
                  defaultValue: "Decrease",
                })}
                onIncrease={() =>
                  onQuantityChange(article.no, article.quantity + 1)
                }
                onDecrease={() =>
                  onQuantityChange(article.no, article.quantity - 1)
                }
                onQuantityChange={(v) => {
                  const n = typeof v === "string" ? parseInt(v, 10) : v;
                  if (!isNaN(n)) onQuantityChange(article.no, n);
                }}
                onChange={(event) => {
                  const n = parseInt(event.currentTarget.value, 10);
                  if (!isNaN(n)) onQuantityChange(article.no, n);
                }}
              />
            )}
            <FixaButton
              type="secondary"
              iconOnly
              ssrIcon={TrashCanIconPath}
              size="small"
              onClick={() => onDeleteArticle(article.no)}
            />
          </div>
        </li>
      ))}
    </ul>
  );
};
